import React from 'react'
import Header from './Mrmintnew/directives/header'
import Footer from './Mrmintnew/directives/footer'
import { Card, Col, Container, Row } from 'react-bootstrap'

export default function Notice() {
    return (
        <>
            <main>
                <Header />
                <div>
                    <div className="breadcrumb-wrap bg-f br-4">
                        <div className="overlay bg-black op-7" />
                        <div className="container">
                            <div className="breadcrumb-title">
                                <h2>Notice</h2>
                                <ul className="breadcrumb-menu list-style">
                                    <li>
                                        <a href="#">Home</a>
                                    </li>
                                    <li>Notice</li>
                                </ul>
                            </div>
                        </div>
                    </div>

                    <Container className="py-5">
                        <section className="notice_popup">
                            <div>
                                <h2 className="mb-4 text-center">
                                    🚨 IMPORTANT ANNOUNCEMENT: Trading Pause & Blockchain Migration Update
                                </h2>

                                <p>Dear MrMint Community,</p>
                                <p>
                                    We are writing to inform you about an important update regarding MrMint token trading and our upcoming blockchain migration.
                                </p>

                                <h4 className="mt-4">Trading Pause Notice:</h4>
                                <p>
                                    Effective immediately, we are temporarily pausing all trading activities on Centralized Exchanges (CEX) and Decentralized Exchanges (DEX)
                                    due to our ongoing migration to a new blockchain network. This strategic move will enhance our token's performance, security, and utility.
                                </p>

                                <h4 className="mt-4">Interim Trading Solution:</h4>
                                <p>
                                    To ensure our community maintains access to liquidity for buying and selling MRMINT during this transition period, we are proud to launch our
                                    dedicated P2P (Peer-to-Peer) trading platform:
                                    <br />
                                    <a href="https://www.mrmint.exchange" target="_blank" rel="noopener noreferrer" style={{ color: '#4c93ff' }}>
                                        www.mrmint.exchange
                                    </a>
                                </p>

                                <h4 className="mt-4">Fair Launch Pricing:</h4>
                                <p>
                                    The token will be available on our P2P platform at <strong>$0.1565</strong> - the 24-hour high price - to ensure fairness and keep the
                                    community protected during this migration period.
                                </p>

                                <h4 className="mt-4">Getting Started:</h4>
                                <p>
                                    Please refer to the video tutorial and follow step-by-step guide to Start trading MRMINT safely during the migration:
                                </p>

                                <p>
                                    We appreciate your patience and continued support as we work to improve the MrMint ecosystem.
                                    This migration will position us for greater growth and enhanced functionality.
                                </p>

                                <p><strong>Thank you for being part of the MrMint journey!</strong></p>

                                <p className="mt-2">
                                    <strong>Important Reminder:</strong> Please ensure you only use the official P2P platform link provided above and follow the official guides for
                                    your safety and security during this transition period.
                                </p>
                            </div>

                            <div className="mt-5">
                                <h2 className="mb-4 text-center">🚨 महत्वपूर्ण घोषणा: ट्रेडिंग रोकना और ब्लॉकचेन माइग्रेशन अपडेट</h2>

                                <p>प्रिय MrMint समुदाय,</p>
                                <p>
                                    हम आपको MrMint टोकन ट्रेडिंग और हमारे आगामी ब्लॉकचेन माइग्रेशन के बारे में एक महत्वपूर्ण अपडेट के बारे में सूचित करने के लिए लिख रहे हैं।
                                </p>

                                <h4 className="mt-4">ट्रेडिंग रोकने की सूचना:</h4>
                                <p>
                                    तत्काल प्रभाव से, हम नए ब्लॉकचेन नेटवर्क में चल रहे माइग्रेशन के कारण सभी केंद्रीकृत एक्सचेंज (CEX) और विकेंद्रीकृत एक्सचेंज (DEX) पर सभी ट्रेडिंग गतिविधियों को अस्थायी रूप से रोक रहे हैं। यह रणनीतिक कदम हमारे टोकन के प्रदर्शन, सुरक्षा और उपयोगिता को बढ़ाएगा।
                                </p>

                                <h4 className="mt-4">अंतरिम ट्रेडिंग समाधान:</h4>
                                <p>
                                    इस संक्रमण अवधि के दौरान हमारे समुदाय के पास MRMINT खरीदने और बेचने के लिए तरलता का पहुंच बना रहे, इसके लिए हम अपने समर्पित P2P (Peer-to-Peer) ट्रेडिंग प्लेटफॉर्म को लॉन्च करने में गर्व महसूस कर रहे हैं:
                                    <br />
                                    <a href="https://www.mrmint.exchange" target="_blank" rel="noopener noreferrer" style={{ color: '#4c93ff' }}>
                                        www.mrmint.exchange
                                    </a>
                                </p>

                                <h4 className="mt-4">निष्पक्ष लॉन्च मूल्य:</h4>
                                <p>
                                    टोकन हमारे P2P प्लेटफॉर्म पर <strong>$0.1565</strong> - 24 घंटे की उच्च कीमत - पर उपलब्ध होगा ताकि निष्पक्षता सुनिश्चित हो और इस माइग्रेशन अवधि के दौरान समुदाय सुरक्षित रहे।
                                </p>

                                <h4 className="mt-4">शुरुआत करना:</h4>
                                <p>
                                    कृपया वीडियो ट्यूटोरियल को देखें माइग्रेशन के दौरान MRMINT को सुरक्षित रूप से ट्रेड करना शुरू करें -
                                </p>

                                <p>
                                    हम MrMint इकोसिस्टम को बेहतर बनाने के लिए काम करते समय आपके धैर्य और निरंतर समर्थन की सराहना करते हैं। यह माइग्रेशन हमें अधिक विकास और उन्नत कार्यक्षमता के लिए स्थिति प्रदान करेगा।
                                </p>

                                <p><strong>MrMint यात्रा का हिस्सा बनने के लिए धन्यवाद!</strong></p>
                            </div>
                        </section>
                    </Container>
                </div>
                <Footer />
            </main>
        </>
    )
}
